<template>
  <div class="flex flex-col items-start text-white m-4">
    <div class="content-start text-left text-teal-200 text-sm mt-2">Hemos enviado un código numérico a su correo electrónico.</div>
    <div class="content-start text-left text-teal-200 text-sm mt-2">Por favor ingréselo aquí</div>
    <div class="w-20 mt-2"><input type="text" id="codigo" v-model="codigo" maxlength="4" class="text-gray-800 p-1 text-2xl w-full" /></div>
    <div class="text-yellow-500">{{ mensajeLocal || mensaje }}</div>
    <div>
      <button @click="validar" class="bg-paleta-3 hover:bg-blue-700 text-white font-bold mt-5 py-2 px-4 rounded">Validar</button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      codigo: "",
      mensajeLocal: ""
    };
  },
  methods: {
    validar() {
      const codigoEntero = Number(this.codigo);
      if (isNaN(codigoEntero)) {
        this.mensajeLocal = "Código incorrecto";
        return;
      }
      this.mensajeLocal = "";
      this.$store.dispatch("verificarCodigoRecuperacionContrasena", {
        codigo: codigoEntero,
        apiToken: process.env.VUE_APP_API_TOKEN
      });
    }
  },
  computed: {
    ...mapState({
      mensaje: state => state.olvideMiContrasena.mensajeErrorCodigo
    })
  }
};
</script>
